import { Box, CardMedia, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

const HexBar = (props) => {
	
	const [ scale, setScale ] = useState(0);
	
	const hexes = [0, 0, 0, 0, 0, 0, 0, 0];
	
	useEffect(() => {
		setScale(0);
		setTimeout(() => {
			setScale(1);
		}, 100)
	}, []);
	
	return (
		<Box>
			{props.percentages?
				<Stack direction="row"  spacing="-2.5em" justifyContent="center">
					{hexes.map((hex, i) => {
						const targetPercent = (i + 1) * (100 / hexes.length);
						let src = "/hex-bar-red.png";
						if (props.percentages.green >= targetPercent) {
							src = "/hex-bar-green.png";
						}
						else if ((props.percentages.green + props.percentages.amber) >= targetPercent) {
							src = "/hex-bar-orange.png";
						}
						
						return (<CardMedia
							key={`hex_${hex}_${i}`}
							component='img'
							src={src}
							alt="cyber risk hex" 
							sx={{
								width: "5em",
								transform: `scale(${scale})`,
								transition: "all 0.35s cubic-bezier(.47,1.64,.41,.8)",
								transitionDelay: `${i * 0.1}s`
							}}
						/>)
					})}
				</Stack>
			: <React.Fragment/> }
		</Box>
	);

}

export default HexBar;